import { translations } from '@janus.team/janus-particles';
import React from 'react';
import './index.scss';
import * as config from 'config/index.js';

const reload = () => global.location.reload();

// https://github.com/RSS-Engineering/rackspace-fabric-design-system/blob/93d9846b52a97d5775309591686524384ec4a682/design-tokens/demo-app/src/templates/error-500.js/index.js
export const FullPage = ({ code, message }) => {
  const t = translations.useT();
  return (
    <section className="py-12 d-flex flex-column align-items-center">
      <div className="container">
        <div>
          <h1 className="mb-none">{message || t('Something Went Wrong')}</h1>
          <div className="error-number lh-1 mb-4">{code}</div>
        </div>
        <p>{t(`Oops! The server encountered an internal error or misconfiguration and was unable to complete your request. Keep calm and don't worry though.`)}</p>

        <p>{t('You can try one of these options:')}</p>

        <ul>
          <li><a href={'#reload'} onClick={reload}>{t('Try again, refresh page')}</a></li>
          {!config.isRacker() && (
            <li><a href="https://portal.rackspace.com/tickets/create">{t('Create ticket')}</a></li>
          )}
        </ul>
      </div>
    </section>
  );
};